"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8654],{

/***/ 16366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a3": function() { return /* binding */ addFavorite; },
  "r7": function() { return /* binding */ deleteFavorite; },
  "_l": function() { return /* binding */ getFavorites; }
});

// EXTERNAL MODULE: ./api/base-services.request.ts + 1 modules
var base_services_request = __webpack_require__(11882);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
;// CONCATENATED MODULE: ./shared/models/endpoits/clients/favorites/favorites.endpoints.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var FavoritesStatic;

(function (FavoritesStatic) {
  FavoritesStatic["add"] = "/v2/clients/favorites";
  FavoritesStatic["list"] = "/v2/clients/favorites";
})(FavoritesStatic || (FavoritesStatic = {}));

var FavoritesDynamic = {
  /**
   * @member {string}
   * @method DELETE
   * @version 2.0
   * @description Delete favorite property.
   */
  "delete": function _delete(id) {
    return "/v2/clients/favorites/" + id;
  }
};
var FavoritesEndpoints = _objectSpread(_objectSpread({}, FavoritesDynamic), FavoritesStatic);
;// CONCATENATED MODULE: ./api/clients/favorites/favorites.request.ts


function addFavorite(body) {
  return (0,base_services_request/* postRequest */.j0)(FavoritesEndpoints.add, body).then(function (_ref) {
    var data = _ref.data;
    return data.data;
  });
}
function getFavorites(params) {
  return (0,base_services_request/* getRequest */.A_)(FavoritesEndpoints.list, params).then(function (_ref2) {
    var data = _ref2.data;
    return data;
  });
}
function deleteFavorite(id) {
  return (0,base_services_request/* deleteRequest */.Jl)(FavoritesEndpoints["delete"](id)).then(function (_ref3) {
    var data = _ref3.data;
    return data.data;
  });
}

/***/ }),

/***/ 99109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useAppSelector; },
/* harmony export */   "T": function() { return /* binding */ useAppDispatch; }
/* harmony export */ });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9473);

// Use throughout your app instead of plain `useDispatch` and `useSelector`
var useAppDispatch = react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0;
var useAppSelector = react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9;

/***/ }),

/***/ 51860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
 // https://stackoverflow.com/questions/63406435/how-to-detect-window-size-in-next-js-ssr-using-react-hook

function useWindowSize() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    width: undefined,
    height: undefined
  }),
      windowSize = _useState[0],
      setWindowSize = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }

    window.addEventListener("resize", handleResize);
    handleResize();
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);
  return windowSize;
}

/* harmony default export */ __webpack_exports__["Z"] = (useWindowSize);

/***/ }),

/***/ 2:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FavoritePropertyButton; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./api/clients/favorites/favorites.request.ts + 1 modules
var favorites_request = __webpack_require__(16366);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(34386);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(98456);
// EXTERNAL MODULE: ./custom-hooks/redux.hooks.ts
var redux_hooks = __webpack_require__(99109);
// EXTERNAL MODULE: ./store/feature/auth/auth-dialog.slice.ts
var auth_dialog_slice = __webpack_require__(54540);
// EXTERNAL MODULE: ./custom-hooks/useSnackBar.hook.ts
var useSnackBar_hook = __webpack_require__(71652);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./shared/models/const/pages-path.ts
var pages_path = __webpack_require__(1283);
// EXTERNAL MODULE: ./shared/context/show-fav-action-snackbar.context.tsx
var show_fav_action_snackbar_context = __webpack_require__(9094);
;// CONCATENATED MODULE: ./shared/hooks/useFavorites.hook.ts
var favoritesSet = new Set();
var deletedFavoritesSet = new Set();
function useFavorites() {
  return favoritesSet;
}
function useDeletedFavorites() {
  return deletedFavoritesSet;
}
// EXTERNAL MODULE: ./custom-hooks/useGetPersintParamas.hook.ts
var useGetPersintParamas_hook = __webpack_require__(53541);
// EXTERNAL MODULE: ./custom-hooks/data-layer-event.hook.ts
var data_layer_event_hook = __webpack_require__(65198);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components/property-card/favoriteButton.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
















function FavoritePropertyButton(_ref) {
  var _useContext, _detail$agent_list, _ref3, _refererValue$arefere;

  var parent_id = _ref.parent_id,
      is_favorite = _ref.is_favorite,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 34 : _ref$size,
      borderColor = _ref.borderColor,
      fontSize = _ref.fontSize,
      detail = _ref.detail,
      onChangeCallback = _ref.onChangeCallback;
  var user = (0,redux_hooks/* useAppSelector */.C)(function (_ref2) {
    var Auth = _ref2.Auth;
    return Auth.user;
  });
  var dispatch = (0,redux_hooks/* useAppDispatch */.T)();
  var favoritesSet = useFavorites();
  var deletedFavoritesSet = useDeletedFavorites();

  var _useState = (0,react.useState)(!deletedFavoritesSet.has(parent_id) && (!!is_favorite || favoritesSet.has(parent_id))),
      isFavorite = _useState[0],
      setIsFavorite = _useState[1];

  var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();

  var _useSnackBar = (0,useSnackBar_hook/* default */.Z)(),
      showMessage = _useSnackBar.showMessage;

  var favActionMadeFromList = (_useContext = (0,react.useContext)(show_fav_action_snackbar_context/* FavActionMadeFromList */.s)) !== null && _useContext !== void 0 ? _useContext : true;

  var _useDataLayerEvent = (0,data_layer_event_hook/* default */.Z)(),
      event = _useDataLayerEvent.event;

  var refererValue = (0,useGetPersintParamas_hook/* default */.Z)({
    onlyCode: true
  });
  var detail_event = {
    codigo: detail === null || detail === void 0 ? void 0 : detail.parent_id,
    nombre: detail === null || detail === void 0 ? void 0 : detail.slug,
    sector: detail === null || detail === void 0 ? void 0 : detail.sector,
    city: detail === null || detail === void 0 ? void 0 : detail.city,
    tipo_propiedad: detail === null || detail === void 0 ? void 0 : detail.typePropertyLabel,
    precio: detail === null || detail === void 0 ? void 0 : detail.price,
    agent: detail === null || detail === void 0 ? void 0 : (_detail$agent_list = detail.agent_list) === null || _detail$agent_list === void 0 ? void 0 : _detail$agent_list.map(function (agent) {
      return agent.name;
    }),
    isAgencia: refererValue !== null && refererValue !== void 0 && refererValue.areferer ? true : false,
    isAgente: refererValue !== null && refererValue !== void 0 && refererValue.referer ? true : false,
    codigo_referido: (_ref3 = (_refererValue$arefere = refererValue === null || refererValue === void 0 ? void 0 : refererValue.areferer) !== null && _refererValue$arefere !== void 0 ? _refererValue$arefere : refererValue === null || refererValue === void 0 ? void 0 : refererValue.referer) !== null && _ref3 !== void 0 ? _ref3 : null
  };

  var _useMutation = (0,useMutation/* useMutation */.D)(favorites_request/* addFavorite */.a3, {
    onSuccess: function onSuccess() {
      favoritesSet.add(parent_id);
      deletedFavoritesSet["delete"](parent_id);
      setIsFavorite(true);
      showMessage((0,emotion_react_browser_esm/* jsx */.tZ)(Message, {
        action: "saved",
        withLink: favActionMadeFromList
      }), {
        variant: "success"
      });
      queryClient.invalidateQueries(["favorites"]);
      onChangeCallback === null || onChangeCallback === void 0 ? void 0 : onChangeCallback(true);
    }
  }),
      addFav = _useMutation.mutate,
      loadingAdd = _useMutation.isLoading;

  var _useMutation2 = (0,useMutation/* useMutation */.D)(favorites_request/* deleteFavorite */.r7, {
    onSuccess: function onSuccess() {
      favoritesSet["delete"](parent_id);
      deletedFavoritesSet.add(parent_id);
      setIsFavorite(false);
      showMessage((0,emotion_react_browser_esm/* jsx */.tZ)(Message, {
        action: "removed",
        withLink: favActionMadeFromList
      }), {
        variant: "default"
      });
      onChangeCallback === null || onChangeCallback === void 0 ? void 0 : onChangeCallback(false);
    }
  }),
      removeFav = _useMutation2.mutate,
      loadingRemove = _useMutation2.isLoading;

  var handleFavorite = function handleFavorite(e) {
    e.preventDefault();
    if (!user) return dispatch((0,auth_dialog_slice/* openAuthDialog */.dn)("signin"));

    if (!loadingAdd && !loadingRemove) {
      !isFavorite ? addedFavorite(parent_id) : removeFavorite(parent_id);
    }
  };

  var addedFavorite = function addedFavorite(parent_id) {
    addFav({
      realestate_id: parent_id
    });
    event({
      event_name: "add-favorite",
      body: _objectSpread({}, detail_event)
    });
  };

  var removeFavorite = function removeFavorite(parent_id) {
    removeFav(parent_id);
    event({
      event_name: "remove-favorite",
      body: _objectSpread({}, detail_event)
    });
  };

  (0,react.useEffect)(function () {
    if (is_favorite && !deletedFavoritesSet.has(parent_id)) {
      favoritesSet.add(parent_id);
    }
  }, []);
  (0,react.useEffect)(function () {
    setIsFavorite(!deletedFavoritesSet.has(parent_id) && (!!is_favorite || favoritesSet.has(parent_id)));
  }, [is_favorite]);

  var FavButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
    target: "e1xqpret2"
  } : 0)("width:", size, "px;height:", size, "px;border:none;transition:transform 0.5s ease-in-out;background-color:transparent;cursor:pointer;:hover{transform:scale(1.05);}" + ( true ? "" : 0));

  return (0,emotion_react_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
    title: !isFavorite ? "Agregar a favoritos" : "Quitar de favoritos"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, (0,emotion_react_browser_esm/* jsx */.tZ)(FavButton, {
    onClick: handleFavorite,
    id: "favorite-button"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Container, null, loadingAdd || loadingRemove ? (0,emotion_react_browser_esm/* jsx */.tZ)(CircularProgress/* default */.Z, {
    className: "loading",
    color: "inherit",
    thickness: 2,
    size: size - 4
  }) : isFavorite ? (0,emotion_react_browser_esm/* jsx */.tZ)(FavoriteIconFilled, null) : (0,emotion_react_browser_esm/* jsx */.tZ)(FavoriteIconUnfilled, null)))));
}

var Message = function Message(_ref4) {
  var action = _ref4.action,
      withLink = _ref4.withLink;
  var t = (0,next_intl_cjs_production_min.useTranslations)("Favorites");
  return (0,emotion_react_browser_esm/* jsx */.tZ)(SuccessSnackBody, null, t(action), "\xA0", withLink && (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    href: pages_path/* CPagesPath.es.profileFavorites */.K.es.profileFavorites
  }, t("link")));
};

var Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xqpret1"
} : 0)( true ? {
  name: "yo4uoc",
  styles: "position:relative;padding-top:2px;display:flex;justify-content:center;align-items:center;.MuiSvgIcon-root{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);}.loading{opacity:0.5;}"
} : 0);

var SuccessSnackBody = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xqpret0"
} : 0)( true ? {
  name: "a0hj9",
  styles: "a{color:white;font-weight:bold;:hover{text-decoration:underline;}}"
} : 0);

var FavoriteIconUnfilled = function FavoriteIconUnfilled() {
  return (0,emotion_react_browser_esm/* jsx */.tZ)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    "aria-hidden": "true",
    role: "presentation",
    focusable: "false",
    style: {
      display: "block",
      fill: "rgba(0, 0, 0, 0.5)",
      height: "24px",
      width: "24px",
      stroke: "white",
      strokeWidth: 2,
      overflow: "visible"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M16 28c7-4.73 14-10 14-17a6.98 6.98 0 0 0-7-7c-1.8 0-3.58.68-4.95 2.05L16 8.1l-2.05-2.05a6.98 6.98 0 0 0-9.9 0A6.98 6.98 0 0 0 2 11c0 7 7 12.27 14 17z"
  }));
};

var FavoriteIconFilled = function FavoriteIconFilled() {
  return (0,emotion_react_browser_esm/* jsx */.tZ)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    "aria-hidden": "true",
    role: "presentation",
    focusable: "false",
    style: {
      display: "block",
      fill: "var(--color-brand-red-secondary)",
      height: "24px",
      width: "24px",
      stroke: "white",
      strokeWidth: 2,
      overflow: "visible"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M16 28c7-4.73 14-10 14-17a6.98 6.98 0 0 0-7-7c-1.8 0-3.58.68-4.95 2.05L16 8.1l-2.05-2.05a6.98 6.98 0 0 0-9.9 0A6.98 6.98 0 0 0 2 11c0 7 7 12.27 14 17z"
  }));
};

/***/ }),

/***/ 34175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ withAdapter; },
/* harmony export */   "ed": function() { return /* binding */ moneyFormatter; }
/* harmony export */ });
/* unused harmony export adapter */
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36864);
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92777);
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82262);
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10748);
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81531);
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63553);
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37247);
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70917);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }



var moneyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0
});
function adapter(realestate) {
  var _realestate$project, _realestate$project2;

  /**
   * En los resultados de la api falta
   *
   * La ciudad, dirección, especificar la moneda de la propiedad
   *
   */
  var data = {
    image: "",
    isExclusive: false,
    city: "",
    address: "",
    street: "",
    typePropertyLabel: "Casa",
    businessTypeLabel: "Venta",
    price: "",
    parkingLots: 0,
    bathing: 0,
    bedrooms: 0,
    measures: 0,
    half_bathrooms: null,
    code: 0,
    parent_id: 0,
    sector: "",
    is_favorite: null,
    is_collection: false,
    has_trust_entity: false,
    type: "venta"
  };

  if (realestate !== null && realestate !== void 0 && realestate.main_picture) {
    data.image = realestate.main_picture.small;
  }

  if (realestate !== null && realestate !== void 0 && realestate.has_trust_entity) {
    data.has_trust_entity = realestate.has_trust_entity;
  }

  if (realestate !== null && realestate !== void 0 && realestate.is_collection) {
    data.is_collection = realestate.is_collection;
  }

  if ((realestate === null || realestate === void 0 ? void 0 : realestate.arrangement) === "Exclusivo") {
    data.isExclusive = true;
  }

  if (realestate !== null && realestate !== void 0 && realestate.sector) {
    data.street = realestate.sector;
  }

  if (realestate !== null && realestate !== void 0 && realestate.half_bathrooms) {
    data.half_bathrooms = realestate.half_bathrooms;
  }

  if (realestate !== null && realestate !== void 0 && realestate.sector) {
    data.sector = realestate.sector;
  }

  if (realestate !== null && realestate !== void 0 && realestate.city) {
    data.city = realestate.city;
  }

  if (realestate !== null && realestate !== void 0 && realestate.realstate_type) {
    data.typePropertyLabel = realestate.realstate_type;
  }

  if (realestate !== null && realestate !== void 0 && realestate.business_type) {
    data.businessTypeLabel = realestate.business_type;
  }

  if (realestate !== null && realestate !== void 0 && realestate.price && realestate !== null && realestate !== void 0 && realestate.currency) {
    data.price = "".concat(realestate.currency.symbol) + moneyFormatter.format(realestate.price);
  } // if (realestate?.alternative_currency?.iso) {
  // bryan mando a hacer esto


  data.rent_price = "".concat(realestate.alternative_currency && realestate.alternative_currency.symbol && realestate.alternate_price > 0 ? realestate.alternative_currency.symbol : realestate.currency.symbol) + moneyFormatter.format(realestate.alternate_price == 0 || realestate.alternate_price == null ? realestate.price : realestate.alternate_price); // bryan mando a hacer esto
  // }
  // [
  //   "Venta",
  //   "Alquiler",
  //   "Alquiler Amueblado",
  //   "Venta Amueblado",
  //   "Alquiler Linea Blanca",
  //   "Venta Linea Blanca",
  //   "Venta y Alquiler",
  //   "Venta y Alquiler Amueblado",
  //   "Venta y Alquiler Linea Blanca",
  // ];

  if (realestate.business_type) {
    var sale = ["Venta", "Venta Amueblado", "Venta Linea Blanca"].includes(realestate.business_type);
    var rent = ["Alquiler", "Alquiler Amueblado", "Alquiler Linea Blanca"].includes(realestate.business_type);
    var all = ["Venta y Alquiler", "Venta y alquiler amueblado", "Venta y alquiler línea blanca"].includes(realestate.business_type);

    if (sale) {
      data.type = "venta";
    } else if (rent) {
      data.type = "alquiler";
    } else if (all) {
      data.type = "venta y alquiler";
    }
  }

  if (realestate !== null && realestate !== void 0 && realestate.parking_spots) {
    data.parkingLots = realestate.parking_spots;
  }

  if (realestate !== null && realestate !== void 0 && realestate.bathrooms) {
    data.bathing = realestate.bathrooms;
  }

  if (realestate !== null && realestate !== void 0 && realestate.bedrooms) {
    data.bedrooms = realestate.bedrooms;
  }

  if (realestate !== null && realestate !== void 0 && realestate.sqm_construction || realestate !== null && realestate !== void 0 && realestate.sqm_land) {
    var _realestate$sqm_const;

    data.measures = (_realestate$sqm_const = realestate === null || realestate === void 0 ? void 0 : realestate.sqm_construction) !== null && _realestate$sqm_const !== void 0 ? _realestate$sqm_const : realestate === null || realestate === void 0 ? void 0 : realestate.sqm_land;
  }

  if (realestate !== null && realestate !== void 0 && realestate.id) {
    data.code = realestate.id;
  }

  if (realestate.is_favorite !== null) {
    data.is_favorite = !!realestate.is_favorite;
  }

  if (realestate.parent_id) {
    data.parent_id = realestate.parent_id;
  }

  if (realestate !== null && realestate !== void 0 && (_realestate$project = realestate.project) !== null && _realestate$project !== void 0 && _realestate$project.maximum_price && realestate !== null && realestate !== void 0 && (_realestate$project2 = realestate.project) !== null && _realestate$project2 !== void 0 && _realestate$project2.minimum_price) {
    data.minimum_price = "".concat(realestate.currency.symbol) + moneyFormatter.format(realestate.project.minimum_price);
    data.maximum_price = "".concat(realestate.currency.symbol) + moneyFormatter.format(realestate.project.maximum_price);
  }

  return data;
}
function withAdapter(Component) {
  // eslint-disable-next-line react/display-name
  return /*#__PURE__*/function (_React$Component) {
    (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_class2, _React$Component);

    var _super = _createSuper(_class2);

    function _class2(props) {
      var _this;

      (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, _class2);

      _this = _super.call(this, props);

      (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this), "realestate", void 0);

      _this.realestate = adapter(props);
      return _this;
    }

    (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_class2, [{
      key: "render",
      value: function render() {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(Component, (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.realestate, {
          className: this.props.className
        }));
      }
    }]);

    return _class2;
  }(react__WEBPACK_IMPORTED_MODULE_2__.Component);
}

/***/ }),

/***/ 9094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ FavActionMadeFromList; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var FavActionMadeFromList = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(undefined);

/***/ }),

/***/ 54540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dn": function() { return /* binding */ openAuthDialog; },
/* harmony export */   "iw": function() { return /* binding */ closeAuthDialog; }
/* harmony export */ });
/* unused harmony export authDialogSlice */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66741);

var initialState = {
  dialog: null
};
var authDialogSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
  name: "auth-dialog",
  initialState: initialState,
  reducers: {
    open: function open(state, _ref) {
      var payload = _ref.payload;
      state.dialog = payload;
    },
    close: function close(state) {
      state.dialog = null;
    }
  }
});
var _authDialogSlice$acti = authDialogSlice.actions,
    openAuthDialog = _authDialogSlice$acti.open,
    closeAuthDialog = _authDialogSlice$acti.close;

/* harmony default export */ __webpack_exports__["ZP"] = (authDialogSlice.reducer);

/***/ })

}]);